"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleAnswerPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Accordion_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Accordion/Accordion.component");
var SampleAnswerPanel_styled_1 = require("./SampleAnswerPanel.styled");
var ArrowUpRightAndArrowDownLeftFromCenter_1 = __importDefault(require("@greatmindsorg/gmui-icons-lib/dist/ArrowUpRightAndArrowDownLeftFromCenter"));
var Button_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Button/Button.component");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../../api");
var SampleAnswerModal_1 = __importDefault(require("./SampleAnswerModal"));
var SampleAnswerPanel = function (_a) {
    var title = _a.title, label = _a.label, questionNumber = _a.questionNumber, _b = _a.maxCharacters, maxCharacters = _b === void 0 ? 430 : _b, _c = _a.isReadyOnly, isReadyOnly = _c === void 0 ? false : _c, _d = _a.showFullContent, showFullContent = _d === void 0 ? false : _d;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var accordionTitle = title || t('customRubrics.sampleAnswer.title');
    var _e = (0, react_1.useState)(isReadyOnly), isOpenAccordion = _e[0], setIsOpenAccordion = _e[1];
    var _f = (0, react_1.useState)(false), showExpandButton = _f[0], setShowExpandButton = _f[1];
    var _g = (0, react_1.useState)(false), showModal = _g[0], setShowModal = _g[1];
    var _h = (0, react_1.useState)(''), labelText = _h[0], setLabelText = _h[1];
    var onClickExpand = function () {
        setShowModal(true);
    };
    var closeModal = function () {
        setShowModal(false);
    };
    var onClickAccordion = function () {
        if (!isReadyOnly)
            setIsOpenAccordion(!isOpenAccordion);
    };
    var isElementHTML = function (str) {
        if (typeof str !== 'string')
            return false;
        var doc = new DOMParser().parseFromString(str, 'text/html');
        var hasHTMLTags = Array.from(doc.body.childNodes).some(function (node) { return node.nodeType === 1; });
        return hasHTMLTags;
    };
    (0, api_1.useMount)(function () {
        var sampleAnswer;
        var showExpand;
        if (isReadyOnly) {
            sampleAnswer = label;
            showExpand = false;
        }
        else if (isElementHTML(label)) {
            sampleAnswer = label;
            showExpand = !showFullContent;
        }
        else {
            showExpand = showFullContent ? false : label.length > maxCharacters;
            sampleAnswer = showExpand ? "".concat(label.slice(0, maxCharacters), "...") : label;
        }
        setShowExpandButton(showExpand);
        setLabelText(sampleAnswer);
    });
    return ((0, jsx_runtime_1.jsxs)(SampleAnswerPanel_styled_1.StyledSampleAnswerContainer, { isReadyOnly: isReadyOnly, children: [(0, jsx_runtime_1.jsx)(Accordion_component_1.Accordion, { customHideLabel: accordionTitle, customShowLabel: accordionTitle, isOpen: isOpenAccordion, onClick: onClickAccordion, children: (0, jsx_runtime_1.jsx)("div", { className: "accordion-label-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "label-container", children: [(0, api_1.sampleAnswerFromLearnosity)(labelText), showExpandButton && ((0, jsx_runtime_1.jsx)("div", { className: "expand-container", children: (0, jsx_runtime_1.jsxs)(Button_component_1.Button, { className: "expand-button", variant: "tertiary", size: "small", onPress: onClickExpand, children: [(0, jsx_runtime_1.jsx)(Button_component_1.Button.Label, { children: t('customRubrics.sampleAnswer.expandButton') }), (0, jsx_runtime_1.jsx)(Button_component_1.Button.Icon, { position: "right", children: (0, jsx_runtime_1.jsx)(ArrowUpRightAndArrowDownLeftFromCenter_1.default, { title: t('customRubrics.sampleAnswer.expandButton'), iconSize: "s" }) })] }) }))] }) }) }), (0, jsx_runtime_1.jsx)(SampleAnswerModal_1.default, { show: showModal, sampleAnswer: label, questionNumber: questionNumber, closeHandler: closeModal })] }));
};
exports.SampleAnswerPanel = SampleAnswerPanel;
exports.default = exports.SampleAnswerPanel;
